import { get } from '../../client/utils/data';
import { mailChimpApiBaseUrl, initMailChimpActions } from './setup';

export const key = 'mailChimp';

const preload = (api, config) => () =>
  Promise.all([
    api.getIntegrationInstance(),
    get({ apiBaseUrl: mailChimpApiBaseUrl(config.apiBaseUrl) })({
      path: 'preload',
    }),
  ]).then(([instance, { oauthRedirectUri, clientId }]) => ({
    newUser: !instance,
    oauthRedirectUri,
    clientId,
  }));

export const integration = () => ({
  key,
  basic: {
    title: 'mailchimp.widget.title',
    description: 'mailchimp.widget.description',
  },
  requiredPermissions: ['promote-marketing-integrations.manage'],

  detailed: async (api, config) => {
    const { getActions, updateStatus } = initMailChimpActions({
      api,
      config,
      key,
    });

    const status = await updateStatus();

    return new Promise((resolve) =>
      resolve({
        title: 'mailchimp.details-page.title',
        description: 'mailchimp.details-page.subtitle.MI1.5',
        articleId: 'mailchimp.details-page.articleId',
        preload: preload(api, config),
        status,
        actions: getActions(status),
        connectedTitle: 'mailchimp.details-page.status.connected',
        disconnectedTitle: 'mailchimp.details-page.status.disconnected',
      }),
    );
  },
});
